import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { ReminderDialogComponent } from '../../modal/reminder-dialog/reminder-dialog.component';
import { DatePipe } from '@angular/common';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { ListCustData } from './listCustData';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { element } from 'protractor';
import { error } from 'util';

@Component({
  selector: 'app-calling-list',
  templateUrl: './calling-list.component.html',
  styleUrls: ['./calling-list.component.scss'],
  providers: [FilterPipePipe]
})
export class CallingListComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('filterSelect', { static: true }) filterSelect: MatSelect;

  reminderData: any;
  callsToBeMade: number = 0;
  pageSize: number;
  callsMade: number = 0;
  callToggleStatus: boolean = true;
  displayedColumns: string[] = [
    'customerName',
    'serviceType',
    'callType',
    'callStatusDesc',
    'serviceDueDate',
    'lastCallTime',
    'creinputs',
    'followUpTime',
    'remarks'
  ];
  dataSource: any;
  selection: any;
  customerData: any;
  currentDate: string;
  spinner: boolean;
  customersToBeCalled: string;
  callsMade1: string;
  openPopUp: boolean;
  columnsToFilter: any[] = [
    { value: 'serviceType', viewValue: 'Service Type' },
    { value: 'callType', viewValue: 'Call Type' },
    { value: 'customerType', viewValue: 'Customer Type' },
    { value: 'callStatusDesc', viewValue: 'Call Status Desc' }];
  dialogRef: any;
  selectedValue: string;
  selectedCol: string;
  selectedFilter: string;
  filterMap = new Map();
  serviceTypeMap = new Map();
  uniqueServiceType = new Set<string>();
  uniqueCallType = new Set<string>();
  uniqueCustomerType = new Set<string>();
  uniqueCallState = new Set<string>();
  uniqueDueDate = new Set<string>();
  uniquePredicationType = new Set<string>();
  filterValues: string[] = [];
  selectedColValues: string[] = [];
  filteredDataSource: any;
  callFlag: any;
  callStats: any = {};
  userId: string;
  selectedServiceTypeValues: string[] = [];
  selectedCustomerTypeValues: string[] = [];
  selectedCallTypeValues: string[] = [];
  selectedCallStatusValues: string[] = [];
  selectedpredationCodeValues: string[] = [];
  filteredValue: any;
  serviceTypeArray: any = [];
  predationCodeArray: any = [];
  //followupDataSource: any = [];
  custDataSource: string[] = [];
  countryCode: string;
  constructor(private commonService: CommonService, private router: Router, public dialog: MatDialog,
    private toastr: ToastrService, private datePipe: DatePipe, private changeDetectorRefs: ChangeDetectorRef,
    private filterPipePipe: FilterPipePipe, private fb: FormBuilder) { }

  ngOnInit() {
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.countryCode = localStorage.getItem('countryCode');
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    if (localStorage.getItem('selectedServiceTypeValues') != null || localStorage.getItem('selectedServiceTypeValues') != undefined) {
      let selectedServiceTypeValues = JSON.parse(localStorage.getItem('selectedServiceTypeValues'));
      this.selectedServiceTypeValues = selectedServiceTypeValues;
    }

    if (localStorage.getItem('selectedCustomerTypeValues') != null || localStorage.getItem('selectedCustomerTypeValues') != undefined) {
      let selectedCustomerTypeValues = JSON.parse(localStorage.getItem('selectedCustomerTypeValues'));
      this.selectedCustomerTypeValues = selectedCustomerTypeValues;
    }

    if (localStorage.getItem('selectedCallTypeValues') != null || localStorage.getItem('selectedCallTypeValues') != undefined) {
      let selectedCallTypeValues = JSON.parse(localStorage.getItem('selectedCallTypeValues'));
      this.selectedCallTypeValues = selectedCallTypeValues;
    }

    if (localStorage.getItem('selectedCallStatusValues') != null || localStorage.getItem('selectedCallStatusValues') != undefined) {
      let selectedCallStatusValues = JSON.parse(localStorage.getItem('selectedCallStatusValues'));
      this.selectedCallStatusValues = selectedCallStatusValues;
    }

    if (localStorage.getItem('selectedpredationCodeValues') != null || localStorage.getItem('selectedpredationCodeValues') != undefined) {
      let selectedpredationCodeValues = JSON.parse(localStorage.getItem('selectedpredationCodeValues'));
      this.selectedpredationCodeValues = selectedpredationCodeValues;
    }

    if (localStorage.getItem('selectedCol') != null || localStorage.getItem('selectedCol') != undefined) {
      let selectedCol = localStorage.getItem('selectedCol');
      this.selectedCol = selectedCol;
    }

    if (localStorage.getItem('selectedColValues') != null || localStorage.getItem('selectedColValues') != undefined) {
      let selectedColValues = JSON.parse(localStorage.getItem('selectedColValues'));
      this.selectedColValues = selectedColValues;
    }

    if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('callListPageSize'));
      this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }

    if (localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) {
      this.getWorkshopDetails();
    }

    this.commonService.startInterval();
    this.commonService.followupResponse && this.commonService.followupResponse.subscribe((res) => {
      this.commonService.followupDataSource = [];
      if(res['responseCode'] == 0) {
        res['responseData'].forEach((element) => {
          this.commonService.followupDataSource.push(element);
          let callListItem = this.commonService.callListResponseData.find((ele) => {return ele.customerId == element.customerId});
          let index = this.commonService.callListResponseData.findIndex((ele) => {return ele.customerId == element.customerId});
          if(index != -1) {
            this.commonService.callListResponseData.splice(index, 1);
          }
        });
        this.commonService.followupDataSource.forEach((val) => {
          this.commonService.callListResponseData.unshift(val);
        })
      } else {
        this.commonService.followupDataSource = [];
        //this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });

    this.getCreStats();
    this.callListinfo();

    if(!this.commonService.callListResponseData.length){
      this.prepairCallList('Y')
    } else {
      let custRes = this.commonService.customerResponse;
      if(custRes) {
        let customerId = custRes['customerId'];
        this.getCallListCustCode('N', customerId);
      } else {
        this.getCustomerResponse();
        this.setCallListData('Y');
      }
    }
  }

  getCallListCustCode(callDoneInd: string, custCode: string) {
    // this.spinner = true;
    this.commonService.getCustCallList(this.userId, callDoneInd, custCode)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          res['responseData'].forEach((element) => {
            this.custDataSource.push(element);
          });
          // this.spinner = false;
        } else {
          // this.spinner = false;
        }
        this.getCustomerResponse();
        this.setCallListData('Y');
      }, err => {
        // this.spinner = false;
        //this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  getCustomerResponse() {
    let custResp = this.commonService.customerResponse;

    if(custResp) {
      let custId = custResp['customerId'];
      let callListItem = this.commonService.callListResponseData.find((element) => {return element.customerId == custId});
      let index = this.commonService.callListResponseData.findIndex((element) => {return element.customerId == custId});

      if(this.custDataSource[0] && (this.custDataSource[0]['callStatusDesc'] == 'Try Again'
          || this.custDataSource[0]['callStatusDesc'] == 'Pending'
          || this.custDataSource[0]['callStatusDesc'] == 'Pending Try-Again')) {
        if(index != -1) {
          this.commonService.callListResponseData.splice(index, 1);
        }
        this.custDataSource.forEach((element) => {
          this.commonService.callListResponseData.push(element);
        });
      } else if(this.custDataSource[0] && (this.custDataSource[0]['callStatusDesc'] == 'Queued')) {
        if(index != -1) {
          this.commonService.callListResponseData.splice(index, 1, this.custDataSource[0]);
        }
      } else if(this.custDataSource[0] && (this.custDataSource[0]['callStatusDesc'] == 'Try Again Contacted'
        || this.custDataSource[0]['callStatusDesc'] == 'Booking Confirmed'
        || this.custDataSource[0]['callStatusDesc'] == 'No Service')) {
        if(index != -1) {
          this.commonService.callListResponseData.splice(index, 1);
        }
      } else if(this.custDataSource[0] && (this.custDataSource[0]['creinputs'] == 'Contact Fleet Manager')) {
        if(index != -1) {
          this.commonService.callListResponseData.splice(index, 1);
        }
        this.commonService.callListResponseData.unshift(this.custDataSource[0]);
      } else {
        if(index != -1) {
          this.commonService.callListResponseData.splice(index, 1);
        }
      }
    }
    this.commonService.customerResponse = '';
  }

  getCallToBeMadeCallList(flag: string) {
    if(!this.commonService.callListResponseData.length){
      this.prepairCallList(flag)
    } else {
      this.setCallListData(flag);
    }
  }

  // workedCallList(flag: string) {
  //   if(!this.commonService.workedCallListData.length) {
  //     this.prepairCallList(flag)
  //   } else {
  //     this.setCallListData(flag);
  //   }
  // }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('callListPageSize', size);
  }

  /**
  * Name: getWorkshopDetails
  * purpose: To get CRE assigned workshop details
  */
  getWorkshopDetails() {
    //this.spinner = true;
    this.commonService.getWorkshopDetails(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          //this.spinner = false;
          localStorage.setItem('workshops', JSON.stringify(res['responseData']));
        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
    * Name: setupCallScheduler
    * purpose: To show scheduled call remainder
    */
  setupCallScheduler(): void {
    interval(10 * 60 * 1000).subscribe(x => {
      this.commonService.callreminder(this.userId)
        .subscribe(res => {
          if (res['responseCode'] == 0) {
            this.reminderData = res['responseData'];
            if (res['responseData'] && res['responseData'].count > 0) {
              localStorage.setItem('customerCount', this.reminderData.count);
              this.dialog.closeAll();
              this.openReminderDialog(); //open popup
            }
          } else {
            this.toastr.error(res['message'], "Error");
          }
        }, err => {
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    });
  }

  /**
    * Name: openReminderDialog
    * purpose: To open scheduled call remainder dialog
    */
  openReminderDialog(): void {
    const dialogRef = this.dialog.open(ReminderDialogComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (this.router.url == "/calling") {
        this.prepairCallList('Y');
      }
    });
  }

  /**
    * Name: prepairCallList
    * purpose: To get calllist details
    * @param {string} flag - type of call
    */
   prepairCallList(flag: string): void {
    this.spinner = true;
    this.selection = new SelectionModel<ListCustData>(true, []);

    this.commonService.customercallList(this.userId, flag).subscribe(
      (res) => {
        if (res['responseCode'] === 0 && res['responseData'] !== undefined) {
          if (flag === 'Y') {
            this.callFlag = flag;
            this.callToggleStatus = true;
          } else {
            this.callFlag = flag;
            this.callToggleStatus = false;
          }

          let response = res['responseData'];
          if (response.length) {
            if (flag === 'Y') {
              this.commonService.callListResponseData = response;
            }
            response.forEach((data) => {
              if (data.customerName) { // Check if data.customerName is not null or undefined
                if ((data.customerType).toLowerCase() === "lost") {
                  let changeName = data.customerName.split(" - L")[0];
                  data.customerName = changeName;
                }

                let inboundCustomer = data.customerName.includes("- I");
                if (inboundCustomer) {
                  let stringPosition = data.customerName.length;
                  let lostString = data.customerName.substring(stringPosition - 3);
                  if (lostString === "- I") {
                    let changeName = data.customerName.split(" - I")[0];
                    data.customerName = changeName;
                    data.isInboundCall = true;
                  }
                }
              }
            });
          }

          this.callsToBeMade = response.length;

          // Initialize data table and sorting
          this.dataSource = new MatTableDataSource<ListCustData>(response);
          this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;

          this.filterData();

          if (
            (!this.selectedServiceTypeValues || this.selectedServiceTypeValues.length === 0) &&
            (!this.selectedCallTypeValues || this.selectedCallTypeValues.length === 0) &&
            (!this.selectedCustomerTypeValues || this.selectedCustomerTypeValues.length === 0) &&
            (!this.selectedCallStatusValues || this.selectedCallStatusValues.length === 0) &&
            (!this.selectedpredationCodeValues || this.selectedpredationCodeValues.length === 0)
          ) {
            // Initialize filtered table and sorting
            this.filteredDataSource = new MatTableDataSource<ListCustData>(response);
            this.sort.direction = '';
            this.filteredDataSource.sort = this.sort;
            this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
            this.filteredDataSource.paginator = this.paginator;
          }

          this.callsMadeCalculate(response);
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      }
    );
  }

  setCallListData(flag: string) {
    let response;
    if(flag == 'Y') {
      response = this.commonService.callListResponseData
    // } else {
    //   response = this.commonService.workedCallListData
    }

    if (flag == 'Y') {
      this.callFlag = flag;
      this.callToggleStatus = true;
    } else {
      this.callFlag = flag;
      this.callToggleStatus = false;
    }
    if (response.length) {
      //=res['responseData'];
      //console.log("response : "+response.length+" value : ",response);
      // response.forEach(data => {
      //   if (data.customerType && (data.customerType).toLowerCase() == "lost") {
      //     let changeName = data.customerName.split(" - L")[0];
      //     data.customerName = changeName;
      //   }
      //   let inboundCustomer = data.customerName && data.customerName.includes("- I");
      //   let stringPosition = data.customerName && data.customerName.length;
      //   let lostString = data && (data.customerName[stringPosition - 3] + data.customerName[stringPosition - 2] + data.customerName[stringPosition - 1])
      //   if (inboundCustomer && lostString == "- I") {
      //     let changeName = data.customerName.split(" - I")[0];
      //     data.customerName = changeName;
      //     data.isInboundCall = true;
      //   }
      // });

      this.callsToBeMade = response.length;
      //init data table and shorting
      this.dataSource = new MatTableDataSource<ListCustData>(response);
      this.sort.direction = '';
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (data, header) => data[header];
      this.dataSource.paginator = this.paginator;
      this.filterData();
      if ((!this.selectedServiceTypeValues || this.selectedServiceTypeValues.length == 0)
      && (!this.selectedCallTypeValues || this.selectedCallTypeValues.length == 0)
      && (!this.selectedCustomerTypeValues || this.selectedCustomerTypeValues.length == 0)
      && (!this.selectedCallStatusValues || this.selectedCallStatusValues.length == 0)) {
        //init filtered table and shorting
        this.filteredDataSource = new MatTableDataSource<ListCustData>(response);
        this.sort.direction = '';
        this.filteredDataSource.sort = this.sort;
        this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
        this.filteredDataSource.paginator = this.paginator;
      }
      this.callsMadeCalculate(response);
      this.callListinfo();
    }
  }

  /**
    * Name: callListinfo
    * purpose: To get call count info
    */
  callListinfo(): void {
    //this.spinner = true;
    this.commonService.callListinfo(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.customersToBeCalled = res['responseData']['callToBeMade'];
          this.callsMade1 = res['responseData']['callMade'];
          //this.spinner = false;
        } else {
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        //...
      });
  }

  /**
    * Name: getCreStats
    * purpose: To get call count info
    */
  getCreStats(): void {
    //this.spinner = true;
    this.commonService.getCreCallStats(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          //this.spinner = false;
          this.callStats = res['responseData'][0];
        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
    * Name: callsMadeCalculate
    * purpose: To get call made count
    * @param {Array} callsToBeMade - list of calls
    */
  callsMadeCalculate(callsToBeMade: any) {
    this.callsMade = 0;
    callsToBeMade.forEach(element => {
      let currentDate = "" + this.datePipe.transform(new Date(), "yyyy-MM-dd");
      let reqDate = this.datePipe.transform((element.lastCallTime), "yyyy-MM-dd");
      if (currentDate == reqDate) {
        this.callsMade++;
      }
    });
  }

  /**
    * Name: selectCustomer
    * purpose: To select customer for details
    * @param {Object} row - selected customer details
    */
  selectCustomer(row: ListCustData): void {
    localStorage.setItem('customerId', row.customerId);
    localStorage.setItem('custNotification', row.serviceType + ", " + row.callStatusDesc);
    localStorage.setItem("customerData", JSON.stringify(row));
    this.router.navigate(['customer360']);
  }

  /**
   * Name: refreshCallList
   * purpose: To refresh call list
   */
  refreshCallList(): void {
    //this.spinner = true;
    this.commonService.customercallList(this.userId, 'Y')
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          this.callsToBeMade = res['responseData'].length;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.callsMadeCalculate(res['responseData']);
          //this.spinner = false;
          this.changeDetectorRefs.detectChanges();
        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: filterData
   * purpose: To filter call list data
   */
  filterData(): void {
    this.dataSource.filteredData.forEach(element => {
      this.uniqueCallState.add(element.callStatusDesc);
      this.uniqueCallType.add(element.callType);
      this.uniqueCustomerType.add(element.customerType);
      this.uniqueServiceType.add(element.serviceType);
      this.uniqueDueDate.add(element.serviceDueDate);
      this.uniquePredicationType.add(element.predationCode);
    });

    this.uniqueServiceType.forEach(element => {
      this.serviceTypeArray.push(element)
    })

    this.uniquePredicationType.forEach(element => {
      // if(element == 'D') {
      //   this.predationCodeArray.push({ value: 'D', viewValue: 'PBBI' })
      // }
      // else 
      if(element == 'I') {
        this.predationCodeArray.push({ value: 'I', viewValue: 'Inbound' })
      } else if(element == 'M') {
        this.predationCodeArray.push({ value: 'M', viewValue: 'Mileage' })
      } else if(element == 'D') {
        this.predationCodeArray.push({ value: 'D', viewValue: 'Date' })
      } else if(element == 'A') {
        this.predationCodeArray.push({ value: 'A', viewValue: 'App' })
      }
    })

    if ((this.selectedServiceTypeValues != null && this.selectedServiceTypeValues.length != 0)
    || (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0)
    || (this.selectedCustomerTypeValues != null && this.selectedCustomerTypeValues.length != 0)
    || (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0)
    || (this.selectedpredationCodeValues != null && this.selectedpredationCodeValues.length != 0)) {
      //this.filterTriggered(null);
      this.applyfilter();
    }
  }

  /**
   * Name: filterTriggered
   * @param {Event} event - 1st filter data
   * purpose: To set 2nd filter values
   */
  filterTriggered(event: any): void {
    if ((event && event.isUserInput && event.source._selected) || (!event && this.selectedCol)) {
      this.filterValues = [];
      let value = event ? event.source.value : this.selectedCol;
      switch (value) {
        case "serviceType":
          this.uniqueServiceType.forEach(element => {
            this.filterValues.push(element);
          });
          break;
        case "callType":
          this.uniqueCallType.forEach(element => {
            this.filterValues.push(element);
          });
          break;
        case "customerType":
          this.uniqueCustomerType.forEach(element => {
            this.filterValues.push(element);
          });
          break;
        case "callStatusDesc":
          this.uniqueCallState.forEach(element => {
            this.filterValues.push(element);
          });
          break;
        case "serviceDueDate":
          this.uniqueDueDate.forEach(element => {
            this.filterValues.push(element);
          });
          break;
          case "predationCode":
            this.uniquePredicationType.forEach(element => {
              this.filterValues.push(element);
          });
          break;
      }
    }
  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    let key = '';
    this.filterMap = new Map();
    this.filteredDataSource = this.dataSource;
    if (this.selectedServiceTypeValues != null && this.selectedServiceTypeValues.length != 0) {
      key = "serviceType";
      this.filterMap.set(key, this.selectedServiceTypeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.selectedCustomerTypeValues != null && this.selectedCustomerTypeValues.length != 0) {
      key = "customerType";
      this.filterMap.set(key, this.selectedCustomerTypeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0) {
      key = "callType";
      this.filterMap.set(key, this.selectedCallTypeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0) {
      key = "callStatusDesc";
      this.filterMap.set(key, this.selectedCallStatusValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.selectedpredationCodeValues != null && this.selectedpredationCodeValues.length != 0) {
      key = "predationCode";
      this.filterMap.set(key, this.selectedpredationCodeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }
    //this.filterMap.set(this.selectedCol, this.selectedColValues);
    //this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    localStorage.setItem('selectedServiceTypeValues',JSON.stringify(this.selectedServiceTypeValues));
    localStorage.setItem('selectedCustomerTypeValues',JSON.stringify(this.selectedCustomerTypeValues));
    localStorage.setItem('selectedCallTypeValues',JSON.stringify(this.selectedCallTypeValues));
    localStorage.setItem('selectedCallStatusValues',JSON.stringify(this.selectedCallStatusValues));
    localStorage.setItem('selectedpredationCodeValues',JSON.stringify(this.selectedpredationCodeValues));
    //localStorage.setItem('selectedCol', this.selectedCol);
    //localStorage.setItem('selectedColValues', JSON.stringify(this.selectedColValues));
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on call list data
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filteredDataSource.filter = filterValue;
  }

  /**
   * Name: clearFilter
   * purpose: To clear filter
   */
  clearFilter(): void {
    this.filterMap.clear();
    this.selectedCol = null;
    this.selectedColValues = null;
    this.selectedServiceTypeValues = null;
    this.selectedCustomerTypeValues = null;
    this.selectedCallTypeValues = null;
    this.selectedCallStatusValues = null;
    this.selectedpredationCodeValues = null;
    this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    localStorage.removeItem('selectedCol');
    localStorage.removeItem('selectedColValues');
    localStorage.removeItem('selectedServiceTypeValues');
    localStorage.removeItem('selectedCustomerTypeValues');
    localStorage.removeItem('selectedCallTypeValues');
    localStorage.removeItem('selectedCallStatusValues');
  }

  /**
   * Name: changeColor
   * purpose: To change followup time color
   */
  changeColor(followUp: any): String {
    let currentTime = this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss ");

    if (followUp != null && followUp != undefined && followUp != "") {
      let followUpDateTime = this.datePipe.transform(followUp, "yyyy-MM-dd HH:mm:ss");
      if ((new Date(currentTime)).getTime() > (new Date(followUpDateTime).getTime())) {
        return "red";
      }
    }
  }

  /**
   * Name: activeButton
   * purpose: To activat apply button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.selectedServiceTypeValues != null && this.selectedServiceTypeValues.length != 0) {
      flag = true;
    } else if (this.selectedCustomerTypeValues != null && this.selectedCustomerTypeValues.length != 0) {
      flag = true;
    } else if (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0) {
      flag = true;
    } else if (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0) {
      flag = true;
    } else if (this.selectedpredationCodeValues != null && this.selectedpredationCodeValues.length != 0) {
      flag = true;
    }
    return flag;
  }

}